import { render } from "./Notice.vue?vue&type=template&id=e2bd789e&scoped=true"
const script = {}

import "./Notice.vue?vue&type=style&index=0&id=e2bd789e&lang=scss&scoped=true"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2bd789e"]])

export default __exports__